module.exports = __webpack_public_path__ + "img/icon_flash_black.a6c9e8ae.svg";